<template>
  <div>
    <Card class="country-general contexte-geopolitique-card">
      <div class="general-header">
        <div style="display: flex; align-items: center;">
          <Icon
            :type="collapsed ? 'ios-arrow-forward' : 'ios-arrow-down'"
            :size="20"
            class="pointer-cursor"
            style="margin-right: 10px"
            @click.native="collapsed = !collapsed"
          />
          <Icon
            type="md-globe"
            :size="25"
            style="margin-right: 15px"
          />
          <strong>{{ $t('Contexte géopolitique') }}</strong>
        </div>
        <div style="display: flex; align-items: center; gap: 10px;">
          <Icon
            v-if="(s2ec.user.is_admin || s2ec.user.is_superuser) && !editMode"
            type="md-create"
            size="20"
            class="pointer-cursor"
            @click.native="toggleEditMode"
          />
          <Icon
            v-if="editMode && (s2ec.user.is_admin || s2ec.user.is_superuser)"
            type="md-close"
            size="20"
            class="pointer-cursor"
            @click.native="cancelEdit"
          />
        </div>
      </div>

      <div v-if="!collapsed && editMode">
        <div v-if="sectionData">
          <h3 v-if="sectionData.titre" style="margin-bottom: 15px;">{{ sectionData.titre }}</h3>
          <Form :label-width="120">
            <FormItem :label="$t('Content')">
              <AppMarkdownEditor
                v-model="editableData.contenu_md"
                :editable="true"
                min-height="400px"
              />
            </FormItem>
          </Form>
        </div>
        <div v-else class="empty-fact-type">
          <h4 class="text-center">{{ $t('No data') }}</h4>
        </div>

        <div class="contexte-geopolitique-actions">
          <Button
            type="default"
            @click="cancelEdit"
          >
            {{ $t('Cancel') }}
          </Button>
          <Button
            type="primary"
            :loading="loading"
            @click="saveSection"
          >
            {{ $t('Save') }}
          </Button>
        </div>
      </div>

      <div v-else-if="!collapsed && !editMode">
        <div v-if="sectionData && sectionData.contenu_md">
          <h3 v-if="sectionData.titre">{{ sectionData.titre }}</h3>
          <div
            class="markdown-content"
            v-html="renderMarkdown(sectionData.contenu_md)"
          />
        </div>

        <div
          v-else
          class="empty-fact-type"
        >
          <h4 class="text-center">
            {{ $t('No data') }}
          </h4>
        </div>
      </div>

      <Spin
        v-if="loading"
        fix
      />
    </Card>
  </div>
</template>

<script>
import { getCountryContentSectionQry, updateCountryContentSectionQry } from "../../../services/countryInfo.service";
import AppMarkdownEditor from '@/components/common/AppMarkdownEditor';
import { marked } from 'marked';

export default {
    name: "ContexteGeopolitique",
    components: {
        AppMarkdownEditor
    },
    data() {
        return {
            loading: false,
            editMode: false,
            collapsed: true,
            sectionData: null,
            editableData: {
                titre: '',
                contenu_md: ''
            },
        }
    },
    created() {
        this.loadSection();
    },
    methods: {
        loadSection() {
            this.loading = true;
            getCountryContentSectionQry(this.$route.params.country.toUpperCase(), 'Contexte géopolitique')
                .then(res => {
                    this.sectionData = res.data;
                })
                .catch(() => {
                    this.$Message.error({
                        content: this.$t('Unable to retrieve contexte géopolitique'),
                        duration: 5
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        toggleEditMode() {
            this.editMode = true;

            // Clone the data for editing
            if (this.sectionData) {
                try {
                    if (this.$lodash && this.$lodash.cloneDeep) {
                        this.editableData = this.$lodash.cloneDeep(this.sectionData);
                    } else {
                        this.editableData = JSON.parse(JSON.stringify(this.sectionData));
                    }
                } catch (e) {
                    this.editableData = { ...this.sectionData };
                }
            }
        },

        cancelEdit() {
            this.editMode = false;
            this.editableData = {
                titre: '',
                contenu_md: ''
            };
        },

        saveSection() {
            this.loading = true;

            const dataToSend = {
                contenu_md: this.editableData.contenu_md
            };

            updateCountryContentSectionQry(this.$route.params.country.toUpperCase(), 'Contexte géopolitique', dataToSend)
                .then(() => {
                    this.$Message.success({
                        content: this.$t('Successfully updated contexte géopolitique'),
                        duration: 3
                    });
                    // Reload the data
                    this.loadSection();
                    // Exit edit mode
                    this.cancelEdit();
                })
                .catch((error) => {
                    console.error('Error updating contexte géopolitique:', error);
                    this.$Message.error({
                        content: this.$t('Error updating contexte géopolitique'),
                        duration: 5
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        renderMarkdown(markdown) {
            if (!markdown) return '';
            try {
                marked.setOptions({
                    breaks: true,
                    gfm: true
                });
                return marked(markdown);
            } catch (error) {
                console.error('Markdown rendering error:', error);
                return markdown;
            }
        }
    }
}
</script>